import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';

const Sidebar = () => {
    const { user } = useAuthContext();
    const navigate = useNavigate();
    const [isCollapsed, setIsCollapsed] = useState(false);

    const isGod   = user?.profiles?.includes('GOD');
    const isAdmin = user?.profiles?.includes('ADMIN');
    const isUser  = user?.profiles?.includes('USER');

    const linkBase    = 'dashboard-link flex items-center py-2 px-3 rounded-lg transition';
    const linkActive  = 'text-white bg-white/20';
    const linkInactive = 'text-blue-100 hover:text-white hover:bg-white/10';

    return (
        <div
            id="sidebar"
            className={`sidebar gradient-bg text-white ${isCollapsed ? 'w-20' : 'w-64'} flex-shrink-0 flex flex-col transition-all duration-300`}
        >
            {/* Header */}
            <div className="p-4 flex items-center justify-between border-b border-white/10">
                <div
                    className={`flex items-center space-x-2 cursor-pointer ${isCollapsed ? 'hidden' : ''}`}
                    onClick={() => navigate('/dashboard/home')}
                >
                    <img src="/logo_lockup_on_dark.svg" alt="StockEasy" className="h-10 sidebar-text" />
                </div>
                <button
                    id="toggleSidebar"
                    className="text-blue-200 hover:text-white transition"
                    onClick={() => setIsCollapsed(v => !v)}
                >
                    <i className={`fas ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
                </button>
            </div>

            {/* Nav */}
            <div className="flex-grow overflow-y-auto">
                <nav className="p-4">
                    <div className="mb-8">
                        <p className={`text-blue-200 uppercase text-xs font-semibold mb-3 sidebar-text ${isCollapsed ? 'hidden' : ''}`}>
                            Main
                        </p>
                        <ul className="space-y-1">
                            <li>
                                <NavLink
                                    to="/dashboard/home"
                                    className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                                >
                                    <i className="fas fa-home sidebar-icon mr-3"></i>
                                    <span className={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>Home</span>
                                </NavLink>
                            </li>

                            {(isUser || isAdmin) && (
                                <li>
                                    <NavLink
                                        to="/dashboard/scanning-session"
                                        className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                                    >
                                        <i className="fas fa-barcode sidebar-icon mr-3"></i>
                                        <span className={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>Sessions</span>
                                    </NavLink>
                                </li>
                            )}

                            {(isUser || isAdmin) && (
                                <li>
                                    <NavLink
                                        to="/dashboard/item-search"
                                        className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                                    >
                                        <i className="fas fa-search sidebar-icon mr-3"></i>
                                        <span className={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>Item Search</span>
                                    </NavLink>
                                </li>
                            )}

                            {(isGod || isAdmin) && (
                                <li>
                                    <NavLink
                                        to="/dashboard/users"
                                        className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                                    >
                                        <i className="fas fa-users sidebar-icon mr-3"></i>
                                        <span className={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>Manage Users</span>
                                    </NavLink>
                                </li>
                            )}

                            {isGod && (
                                <li>
                                    <NavLink
                                        to="/dashboard/licenses"
                                        className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                                    >
                                        <i className="fas fa-list sidebar-icon mr-3"></i>
                                        <span className={`sidebar-text ${isCollapsed ? 'hidden' : ''}`}>Manage Licenses</span>
                                    </NavLink>
                                </li>
                            )}
                        </ul>
                    </div>
                </nav>
            </div>

        </div>
    );
};

export default Sidebar;
